var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultation",on:{"click":_vm.ShowClick}},[_c('img',{staticClass:"consultation-icon",attrs:{"src":require("@/assets/icon/icon_message.png"),"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"consultation-title"},[_c('h1',[_vm._v("在线咨询")])])
}]

export { render, staticRenderFns }